<template>
  <div class="home container is-fluid">
		<div class="countdown" v-show="countdown">
			{{currentProgress}}
		</div>
		<div class="container is-fixed">
			<div class="notification is-info">
				<div class="content">
					<h3 class="is-medium">Slips, Trips, and Falls</h3>
				</div>
				<div class="content" v-show="state === 'waiting' && !signedIn">
					<p class="content instruction">
						Please enter your name to login.
					</p>
				</div>
				<div class="content" v-show="state === 'waiting' && signedIn">
					<p class="content instruction">
						Wait for the leader to start the exercise.
					</p>
				</div>
			</div>
		</div>
		<div class="container" v-show="signedIn && adminState === 'waiting'">
			<div class="notification">
			  <p>Did You Know?</p>
				<p>Falls are the third leading cause of unintentional death in the U.S., accounting for nearly 32,000 deaths in 2014, according to Injury Facts 2016®. The risk of falling rises with age.</p>
			</div>
		</div>
		<div class="container" v-show="!signedIn">
		<div class="field">
  		<div class="control">
    		<input v-model="username" class="input" type="text" placeholder="Username">
  		</div>
		</div>
		<div class="field">
  		<p class="control">
    	<button v-on:click="signIn" class="button is-info">
      	Login
    	</button>
  		</p>
		</div>
		</div>
		<Scenarios
			v-bind:message="addedMessage"
			v-bind:mode="mode"
			v-bind:admin="adminScene"
			v-on:message="deliverMessage"
			v-bind:randomSet="2"
		/>
		<div class="container" v-show="adminState === 'end'">
		<div class="field">
			<label class="label">How will you use what you've learned today?</label>
  		<div class="control">
    		<textarea v-model="appliedLearning" class="input" type="text"></textarea>
  		</div>
		</div>
		<div class="field">
  		<p class="control">
    	<button v-on:click="submitFinal" class="button is-info">
      	Send Response
    	</button>
  		</p>
		</div>
		</div>
  </div>
</template>

<script>
import Scenarios from '../components/Scenarios'

// @ is an alias to /src
export default {
  name: 'user',
	components: {
		Scenarios
	},
  data() {
    return {
      pubnub: this.$pnGetInstance(),
      channelPrefix: 'tooltalk',
      state: 'waiting',
			mode: 'none',
      adminState: 'waiting',
      counter: null,
      participants: [],
			adminScene: '',
      participantId: null,
      username: null,
      userData: null,
      signedIn: false,
      countdown: false,
      currentTime: 5000,
      currentProgress: 0,
      actChosenTime: 5000,
      actTime: 12000,
      currentActivityIndex: 0,
      results: [],
      pnMessages: [],
			addedMessage: {}
    }
  },
  methods: {
    progressCountdown( e ) {
      this.currentProgress = Math.floor( ( this.actTime - ( e.seconds * 1000 + e.milliseconds ) ) / 100 ) / 10
    },
    endCountdown() {
      this.currentProgress = 0
      this.countdown = false
    },
    postCorrect( correct, candle ) {
      if ( correct ) {
        this.$pnPublish( {
          channel: this.completeChannel,
          message: {
            correct: true,
            time: this.currentProgress
          }
        } )
      }
    },
    postResults( message ) {
      if ( message.results ) {
        this.results = message.results
      }
    },
		deliverMessage( msg ) {
			this.$pnPublish( {
				channel: this.messagesChannel,
				message: {
					username: this.username,
					guess: msg.guess,
					name: msg.name
				}
			} )
		},
    checkUsername() {},
    signIn() {
      this.$pnPublish( {
        channel: [ this.userChannel ],
				message: {
					username: this.username
				}
      } )
      this.signedIn = true
    },
    prepActivity( message ) {
      const activityId = this.patterns.findIndex( p => p.id === message.activity.id )
      this.currentActivityIndex = activityId || 0
      this.actTime = message.timing.activity
      this.actChosenTime = message.timing.notify
      this.countdown = true
      this.currentTime = this.actChosenTime
    },
    startActivity( response ) {
      this.countdown = true
      this.currentTime = this.actTime
			this.mode = 'random'
			this.currentProgress = response.message.timing/1000
			const startInterval = setInterval(() => {
				this.currentProgress -= 1
				if (this.currentProgress === 0) {
					clearInterval(startInterval)
					this.reviewActivity()
					this.endCountdown()
				}
			}, 1000)
    },
		reviewActivity() {
			this.mode = 'review'
		},
		endActivity() {
			this.mode = 'none'
		},
		submitFinal() {
			
		},
		focusActivity(msg) {
			this.adminScene = msg.focused ? msg.name : ''
		},
    stateChange( response ) {
			if (response.message.state) {
				this.adminState = response.message.state
				if (this.adminState === 'start') this.startActivity( response )
				if (this.adminState === 'end') this.endActivity()
				if (this.adminState === 'focus') this.focusActivity( response.message )
			} else if (response.message && response.message.guess) {
				this.logMessage( response.message )
			}
    },
		logMessage( msg ) {
			this.addedMessage = msg
		}
  },
  computed: {
		adminChannel() {
      return `${this.channelPrefix}_admin`
    },
    messagesChannel() {
      return `${this.channelPrefix}_messages`
    },
		userChannel() {
			return `${this.channelPrefix}_users`
		},
    incomingChannels() {
      return [ this.adminChannel, this.messagesChannel ]
    },
    actTimeSeconds() {
      return Math.floor( this.actTime / 1000 )
    }
  },
  watch: {
    adminState() {
			this.state = this.adminState
    }
  },
  mounted() {
    const v = this
    const listener = {
      message( response ) {
        v.stateChange( response )
      }
    }
    this.$pnSubscribe( {
      channels: this.incomingChannels
    } )
    this.pubnub.addListener( listener )
  }
}
</script>

<style>

.is-fixed {
	position: -webkit-sticky !important; /* Safari */
	position: sticky !important;
	height: auto;
	z-index: 100;
	top: 0;
	left: 0;
	width: 100%;
	margin-bottom: 2em;
}

.is-fixed .content h3 {
	color: white;
}

.container.is-fixed {
	margin-bottom: 1em;
}


	.content {
		text-align: 'left';
	}


	.countdown {
		position: fixed;
		bottom: 0;
		right: 0;
		background-color: rgba(0, 0, 0, .5);
		height: 2.5em;
		border-radius: 0;
		width: 2.5em;
		color: white;
		font-size: 1.5em;
		z-index: 200;
		padding: 0.5em;
	}


</style>
